import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { StorefrontApp } from './storefront-app';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('ROOT_ELEMENT_NOT_FOUND');

createRoot(root).render(
  <StrictMode>
    <StorefrontApp />
  </StrictMode>,
);
